/* Lab Effects — Cart drawer free-shipping progress bar.
   Repaints the bar from the cart subtotal. Self-wires to Horizon's native cart
   pub-sub ('cart:update', see assets/events.js) exactly like assets/cart-icon.js,
   so it stays live on add / qty change / remove WITHOUT modifying any Horizon JS.
   The Liquid snippet renders the correct first-paint state; this only animates. */
(function(){
  var TRUCK='<path d="M1 3h13v13H1zM14 8h4l3 3v5h-7z"/><circle cx="5.5" cy="18.5" r="2"/><circle cx="17.5" cy="18.5" r="2"/>';
  var CHECK='<path d="M20 6L9 17l-5-5"/>';
  var last=null;

  // Match Shopify's money_without_trailing_zeros: whole -> "$100", cents -> "$74.50".
  function money(cents){
    var v=cents/100;
    var s=(v%1===0)?v.toFixed(0):v.toFixed(2);
    var p=s.split('.');
    p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,',');
    return '$'+p.join('.');
  }

  // Replace every {amount} token in a merchant-edited string.
  function fill(tmpl,val){ return String(tmpl||'').split('[amount]').join(val); }

  function update(subtotalCents){
    var el=document.querySelector('.le-fs');
    if(!el) return;
    var threshold=parseInt(el.dataset.threshold,10)||10000;
    var eyebrowT=el.dataset.eyebrow||'';
    var messageT=el.dataset.message||'';
    var unlockedLabel=el.dataset.unlockedLabel||'Unlocked';
    var remaining=threshold-subtotalCents;
    var pct=Math.max(0,Math.min(100,(subtotalCents/threshold)*100));

    el.querySelector('.le-fs__fill').style.width=pct+'%';

    var eyebrow=el.querySelector('.le-fs__eyebrow');
    var msg=el.querySelector('.le-fs__msg');
    var ico=el.querySelector('.le-fs__ico svg');

    if(remaining<=0){
      el.classList.add('is-qualified');
      eyebrow.textContent=unlockedLabel;
      msg.innerHTML='<b>Free shipping applied.</b><br>Your order ships on us.';
      ico.innerHTML=CHECK;
    }else{
      el.classList.remove('is-qualified');
      eyebrow.textContent=fill(eyebrowT,money(threshold));
      msg.innerHTML=fill(messageT,'<b>'+money(remaining)+'</b>');
      ico.innerHTML=TRUCK;
    }

    // icon pulse only when the number actually moved
    if(last!==null && last!==subtotalCents){
      el.classList.remove('is-bumped');
      void el.offsetWidth;
      el.classList.add('is-bumped');
    }
    last=subtotalCents;
  }

  window.LEFreeShipping={update:update};

  // Last known authoritative cart, used for optimistic math below.
  var cartState=null;

  // Shiptection protection never counts toward free shipping (see
  // snippets/le-shiptection.liquid), so it is taken out of every total here.
  var SHPT='shiptection-shipping-protection';
  function goods(c){
    var t=c.total_price;
    (c.items||[]).forEach(function(it){ if(it.handle===SHPT) t-=it.final_line_price; });
    return t;
  }

  // initial paint from the value rendered by Liquid
  function paintFromDom(){
    var el=document.querySelector('.le-fs');
    if(el) update(parseInt(el.dataset.subtotal,10)||0);
  }
  if(document.readyState!=='loading') paintFromDom();
  else document.addEventListener('DOMContentLoaded',paintFromDom);
  // seed the cart snapshot so the first optimistic tick is correct
  fetch('/cart.js').then(function(r){return r.json();}).then(function(c){ cartState=c; }).catch(function(){});

  // INSTANT feedback: 'quantity-selector:update' fires on the click, BEFORE Horizon's
  // 300ms quantity debounce (see component-cart-items.js). We recompute the subtotal
  // from the last cart snapshot so the bar moves immediately; cart:update reconciles.
  document.addEventListener('quantity-selector:update',function(e){
    var d=e&&e.detail; if(!d) return;
    var line=d.cartLine, qty=d.quantity;
    if(!line||line<1||typeof qty!=='number') return;          // ignore non-cart (e.g. PDP) selectors
    if(!cartState||!cartState.items||!cartState.items[line-1]) return;
    var it=cartState.items[line-1];
    var optimistic=goods(cartState) - it.final_line_price + (it.final_price*qty);
    update(optimistic);
  });

  // authoritative reconcile — mirror cart-icon.js: listen for the native cart:update event.
  document.addEventListener('cart:update',function(e){
    var res=e && e.detail && e.detail.resource;
    if(res && typeof res.total_price==='number'){ cartState=res; update(goods(res)); return; }
    // fallback if the event didn't carry the new cart object
    fetch('/cart.js').then(function(r){return r.json();})
      .then(function(c){ cartState=c; update(goods(c)); })
      .catch(function(){});
  });
})();
